import { BaseEntity } from '../../../models';
import { OrigemLancamentoCadastro } from '../../../models/origem-lancamento-cadastro';
import { OrigemID, Origem } from '../../common/origens/domain';
import { CanalVenda } from '../../common/canais-venda/domain';
import { pessoaJuridica } from '../../pessoa/tipo';
import { IPeriodicidadeCompra } from '../../../domains/environment/periodicidade-compra/interfaces/periodicidade-compra.interface';
import { LeadClassificacao } from './classificacao';
import { LeadContato } from './contato';
import { contatoTipoPrincipal } from '../../pessoa/contato';
import { LeadEndereco } from './endereco';
import { enderecoTipoPrincipal } from '../../pessoa/endereco';
import { Usuario } from '../../usuario';
import { Campanha } from '../../campanhas/campanhas';
import { CNAE } from '../../cnaes';
import { LeadCNAESecundaria } from './cnaes-secundarias';
import { LeadSocio } from './socios';
import { Regiao } from '../../regiao/regiao';

export class Lead implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    idUsuarioCreated: number;
    origemCadastro: number;
    /** Data de Abertura/Inicio das atividades da empresa */
    dataFundacao: Date;
    dataCadastro: Date;
    exterior: boolean;
    tipoPessoa: number;
    cnpjCpf: string;
    identificadorMatrizFilial: number;
    nome: string;
    nomeFantasia: string;
    idPeriodicidadeCompra: number;
    periodicidadeCompra: IPeriodicidadeCompra;

    /** Origem */
    origem: OrigemID;
    // Campanhas
    idCampanhaOrigem: number;
    campanhaOrigem: Campanha;
    // Mídia Social
    canalMidiaSocial: number;
    // Canal de Venda
    idCanalVendaOrigem: number;
    canalVendaOrigem: CanalVenda;

    // Qualificação
    idCampanhaQualificacao: number;
    campanhaQualificacao: Campanha;

    // Situação Cadastral
    situacaoCadastral: number;
    situacaoCadastralData: Date;
    situacaoCadastralMotivoCodigo: number;
    situacaoCadastralMotivoNome: string;

    // Natureza Juridica
    naturezaJuridicaCodigo: number;
    naturezaJuridicaNome: string;

    // Porte da Empresa
    porteEmpresaCodigo: number;
    porteEmpresaNome: string;

    // CNAEs
    idCNAEPrincipal: number;
    cnaePrincipal: CNAE;
    cnaesSecundarias: LeadCNAESecundaria[];

    // Região
    idRegiao: number;
    regiao: Regiao;

    // Internet
    site: string;
    emailNfe: string;
    emailBoleto: string;

    // Contatos
    contatoPrincipal: LeadContato;
    contatoCobranca: LeadContato;
    contatoEntrega: LeadContato;
    outrosContatos: LeadContato[];

    // Endereços
    enderecoPrincipal: LeadEndereco;
    enderecoCobranca: LeadEndereco;
    enderecoEntrega: LeadEndereco;

    // Classificações
    classificacoesNome: string;
    classificacoes: LeadClassificacao[];

    // Capital Social e Quadro de Sócios e Administradores - QSA
    capitalSocial: number;
    socios: LeadSocio[];

    // Simples Nacional
    optanteSimplesNacional: boolean;
    optanteSimplesNacionalData: Date;
    optanteSimplesNacionalDataExclusao: Date;

    // MEI
    optanteMEI: boolean;
    optanteMEIData: Date;
    optanteMEIDataExclusao: Date;

    temperatura: number;
    idUsuarioResponsavel: number;
    usuarioResponsavel: Usuario;
    anotacao: string;

    constructor(origemCadastro: OrigemLancamentoCadastro, origem: Origem = null, tipoPessoa: number = null) {
        this.origemCadastro = origemCadastro?.id ?? null;
        this.origem = origem ? origem.id : null;

        this.tipoPessoa = tipoPessoa ?? pessoaJuridica.id;
        this.classificacoes = [];

        // Contatos
        this.contatoPrincipal = new LeadContato(contatoTipoPrincipal.id);
        this.outrosContatos = [];

        // Endereço
        this.enderecoPrincipal = new LeadEndereco(enderecoTipoPrincipal.id);
    }
}
